import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { Constants } from '../constants';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private sharedService: SharedService
    ) { }

    canActivate(): Observable<boolean> {
        let tokenConfig = this.sharedService.getTokenConfig();
        if (tokenConfig && tokenConfig.encryptedToken) {
            return this.authService.IsAuthorized(tokenConfig.encryptedToken).pipe(
                map(isAuthorized => {
                        if (isAuthorized) {
                            return true;
                        } else {
                            this.sharedService.navigateByDisplayMode('home');
                            return false;
                        }
                    }),
                    catchError(() => {
                        this.sharedService.navigate([Constants.RedirectUrl.Auth]);
                        return of(false);
                    })
                );
        } else {
            this.sharedService.navigate([Constants.RedirectUrl.Auth]);
            return of(false);
        }
    }      

}